function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.942 16.57L14 8.335V5h.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-5c-.275 0-.5.225-.5.5s.225.5.5.5h.5v3.335L5.058 16.57C3.926 18.456 4.8 20 7 20h10c2.2 0 3.074-1.543 1.942-3.43zM7.766 14L11 8.61V5h2v3.61L16.234 14H7.766z"
});

function SvgExperimentsNav(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentsNav);
export default __webpack_public_path__ + "static/media/experiments-nav.1947eb4b4778ba90a8beebaed2a9554b.svg";
export { ForwardRef as ReactComponent };